<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <button
        class="system-button absolute right-4 top-4"
        @click.prevent="close"
      >
        <close-icon class="w-8 fill-current" />
      </button>

      <form @submit.prevent="save">
        <div class="flex flex-col w-full mt-2">
          <label for="max"
            >De {{ minValue > 0 ? "más de " : "" }} {{ minValue }} km a</label
          >
          <input
            id="max"
            type="number"
            v-model="max"
            :min="0"
            step="any"
            :disabled="isEditing"
          />
          <label for="max">km (Máximo {{ branch.max_distance }} km)</label>
          <validation-errors :errors="errorFor('max')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-2">
          <label for="price">Precio</label>
          <input id="price" type="number" :min="0" v-model="price" step="any" />
          <validation-errors :errors="errorFor('price')"></validation-errors>
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Actualizar" : "Crear" }}
        </primary-button>
      </form>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
import api from "@/api";
export default {
  name: "Local Delivery Range Modal",

  data() {
    return {
      max: "",
      price: "",
      loading: false,
      loadingForm: false,
      isEditing: false,
    };
  },

  props: {
    range: Object,
    branch: Object,
  },

  mixins: [validationErrors],

  computed: {
    minValue() {
      if (!this.range) {
        if (!this.branch || this.branch.local_delivery_ranges.length === 0) {
          return 0;
        }

        return this.branch.local_delivery_ranges[
          this.branch.local_delivery_ranges.length - 1
        ].max;
      } else {
        return this.range.min;
      }
    },
  },

  created() {
    if (this.range) {
      this.isEditing = true;
      this.max = this.range.max;
      this.price = this.range.price;
    }
  },

  methods: {
    close() {
      this.$emit("close");
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createRange();
      } else {
        this.updateRange();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.max) {
        this.errors["max"] = ["Campo requerido"];
      }

      if (this.max > this.branch.max_distance) {
        this.errors["max"] = [
          "La distancia no puede superar el límite de envío de la sucursal",
        ];
      }

      if (!this.price) {
        this.errors["price"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createRange() {
      this.loadingForm = true;

      const request = {
        min: this.minValue,
        max: this.max,
        price: this.price,
        branch_id: this.branch.id,
      };

      try {
        const response = await api.ranges.create(request);
        this.$store.dispatch("successSnack", response.message);
        this.$emit("updateRanges");
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateRange() {
      this.loadingForm = true;

      const request = {
        price: this.price,
      };

      try {
        const response = await api.ranges.update(this.range.id, request);
        this.$store.dispatch("successSnack", response.message);
        this.$emit("updateRanges");
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>